import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getWhdStatement } from 'actions';

export const PUBLISH_WHD_STMT_REQUEST = 'PUBLISH_WHD_STMT_REQUEST';
export const PUBLISH_WHD_STMT_SUCCESS = 'PUBLISH_WHD_STMT_SUCCESS';
export const PUBLISH_WHD_STMT_FAILURE = 'PUBLISH_WHD_STMT_FAILURE';

function request() {
  return {
    type: PUBLISH_WHD_STMT_REQUEST
  };
}

function receive(versionWindow) {
  return {
    type: PUBLISH_WHD_STMT_SUCCESS,
    effectiveDate: versionWindow.effectiveFromDate,
    effectiveToDate: versionWindow.effectiveToDate
  };
}

function reject() {
  return {
    type: PUBLISH_WHD_STMT_FAILURE
  };
}

export function publishStatement(accountId, versionWindow) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .publishStatement(accountId, versionWindow)
      .then((response) => {
        if (!response.data) {
          toastr.success('Publish Failed', 'There was a problem publishing the statement');
        } else {
          dispatch(receive(versionWindow));
          dispatch(getWhdStatement([accountId]));
          toastr.success('Publish Successful', `Statement Version ${ response.data.version } ${ response.data.isRepublish ? 're' : '' }published`);
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(reject(accountId)), true)));

    return promise();
  };
}
